/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LoanDetailedList { 
    id?: number;
    accountId?: number;
    accountNumber?: string | null;
    memberName?: string | null;
    loanOfficerUserId?: number;
    loanOfficerName?: string | null;
    tenure?: number;
    creationTime?: string;
    principalAmount?: number;
    outstandingPrincipal?: number | null;
    outstandingInterestAmount?: number | null;
    balance?: number;
    loanProductName?: string | null;
    tenurePeriodTypeTitle?: string | null;
    statusId?: number;
    statusTitle?: string | null;
    maxOverdueInstallementDays?: number | null;
    loanProvisioningStatus?: string | null;
}

